import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChain = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 11.0012C13.5705 10.4271 13.0226 9.95202 12.3934 9.60826C11.7642 9.2645 11.0684 9.06009 10.3533 9.00887C9.63816 8.95765 8.92037 9.06083 8.24861 9.31142C7.57685 9.56201 6.96684 9.95413 6.45996 10.4612L3.45996 13.4612C2.54917 14.4042 2.04519 15.6672 2.05659 16.9782C2.06798 18.2892 2.59382 19.5433 3.52086 20.4703C4.4479 21.3973 5.70197 21.9232 7.01295 21.9346C8.32393 21.946 9.58694 21.442 10.53 20.5312L12.24 18.8212",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgChain;
